import { FC } from "react";
import Lightbox from "yet-another-react-lightbox";
import useLightBoxContext from "../../../hooks/useLightbox";

export const LightBox: FC = () => {
  const { open, images, setOpen } = useLightBoxContext();
  return (
    <Lightbox
      open={open}
      close={() => { setOpen(false) }}
      slides={
        images.map((imgSrc) => {
          const img = { src: imgSrc }
          return img;
        })
      }
    />
  )
}